import React from 'react'
import { Grid, Paper } from '@material-ui/core'
import { LoyaltyProviderPage } from '../../../components/MfeParcels/LoyaltyProviderPage'

export const LoyaltyProviderContainer = ({ disabled, onProvidersChange, tenantName }) => {
  return (
    <div style={{ pointerEvents: disabled ? 'none' : 'auto', opacity: disabled ? 0.5 : 1 }}>
      <Grid container>
        <Grid className="unversalScroll" item xs={12} sm={12} md={12} lg={12}>
          <Paper className="paper-page">
            <h2 className="margin-left-small">New Loyalty System</h2>
            <LoyaltyProviderPage onProvidersChange={onProvidersChange} tenantName={tenantName} />
          </Paper>
        </Grid>
      </Grid>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/containers/Settings/Company/LoyaltyProvidersContainer.js